import React, {
  memo, useEffect, useMemo, useState,
} from 'react'
import Grid from '@mui/material/Grid2'
import MenuItem from '@mui/material/MenuItem'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import clsx from 'clsx'
import CloseIcon from '@mui/icons-material/Close'
import sx from './styles'

const maxPriceOnInventoryDefault = '1450000'

const priceRanges = [
  { value: '100000', label: '$100,000' },
  { value: '200000', label: '$200,000' },
  { value: '300000', label: '$300,000' },
  { value: '400000', label: '$400,000' },
  { value: '500000', label: '$500,000' },
  { value: maxPriceOnInventoryDefault, label: '$+600,000' },
]

const PricesFilter = ({
  onChange,
  minPriceSelected,
  maxPriceSelected,
}) => {
  const [minPrice, setMinPrice] = useState(minPriceSelected || '')
  const [maxPrice, setMaxPrice] = useState(maxPriceSelected || '')
  const minPriceDefault = useMemo(() => priceRanges[0].value, [priceRanges])
  const maxPriceDefault = useMemo(() => [...priceRanges].pop().value, [priceRanges])

  const handleMinPriceChange = (event) => {
    const { value } = event.target
    setMinPrice(value)
    onChange({ min: String(value) })
    // Reset max price if it's less than or equal to the new min price
    if (maxPrice && parseInt(maxPrice) <= parseInt(value)) {
      setMaxPrice('')
    }
  }

  const handleMaxPriceChange = (event) => {
    const { value } = event.target
    if (!minPrice) {
      setMinPrice(minPriceDefault)
      onChange({ min: String(minPriceDefault), max: String(value) })
    }
    setMaxPrice(value)
    onChange({ max: String(value) })
  }

  const getAvailableMinPrices = () => {
    // if (!minPrice) return []
    return priceRanges.filter((range) => parseInt(range.value) < maxPriceDefault)
  }

  const getAvailableMaxPrices = () => {
    // if (!minPrice) return []
    const minPriceValue = minPrice ? parseInt(minPrice) : minPriceDefault
    return priceRanges.filter((range) => parseInt(range.value) > minPriceValue)
  }

  useEffect(() => {
    if (!minPriceSelected) {
      setMinPrice('')
    }
    if (!maxPriceSelected) {
      setMaxPrice('')
    }
  }, [minPriceSelected, maxPriceSelected])

  const clearPrice = (type) => {
    if (type === 'min') {
      setMinPrice('')
      onChange({ min: '' })
    } else {
      setMaxPrice('')
      onChange({ max: '' })
    }
  }

  return (
    <Grid
      container
      gap={1}
      mt={2}
    >
      <Grid size="grow">
        <TextField
          sx={sx.select}
          label="Precio mínimo"
          className={clsx('Mui-style', { touched: minPrice })}
          select
          value={minPrice}
          fullWidth
          SelectProps={{ displayEmpty: true }}
          onChange={handleMinPriceChange}
          InputProps={{
            endAdornment: minPrice && (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  onClick={() => clearPrice('min')}
                >
                  <CloseIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        >
          {getAvailableMinPrices()?.map(({ value, label }) => (
            <MenuItem
              key={value}
              value={value}
            >
              {label}
            </MenuItem>
          ))}
        </TextField>

      </Grid>
      <Grid size="grow">
        <TextField
          sx={sx.select}
          label="Precio máximo"
          className={clsx('Mui-style', { touched: maxPrice })}
          select
          value={maxPrice}
          fullWidth
          SelectProps={{ displayEmpty: true }}
          onChange={handleMaxPriceChange}
          InputProps={{
            endAdornment: maxPrice && (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  onClick={() => clearPrice('max')}
                >
                  <CloseIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        >

          {getAvailableMaxPrices().map(({ value, label }) => (
            <MenuItem
              key={value}
              value={value}
            >
              {label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

    </Grid>
  )
}

export default memo(PricesFilter)
